import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/administration/questionnaires",
    name: "Questionnaires",
    meta: { title: "Vprašalniki" },
    component: () => import(/* webpackChunkName: "Questionnaires List" */ "@/Modules/Questionnaire/Views/List"),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/administration/questionnaires/editor/:id",
    name: "Questionnaire Details",
    meta: { title: "Urejevalnik vprašalnikov" },
    component: () => import(/* webpackChunkName: "Questionnaire Details" */ "@/Modules/Questionnaire/Views/Editor/Editor.vue"),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/administration/questionnaires/new",
    name: "New Questionnaire",
    meta: { title: "Nov vprašalnik" },
    component: () => import(/* webpackChunkName: "Questionnaires Details" */ "@/Modules/Questionnaire/Views/Editor/Editor.vue"),
    beforeEnter: ifAuthenticated
  }
]
